import type { ServiceContractStatus } from '@mnc/contracts';

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);
const pageOf = (v: unknown): number | undefined => {
  const n = Number(v);
  return Number.isInteger(n) && n > 1 ? n : undefined;
};
const STATUSES = ['draft', 'active', 'on_hold', 'completed', 'terminated'];
const VIEWS = ['contracts', 'followups', 'receivables'];
const TABS = ['overview', 'boq', 'variations', 'invoices', 'statement', 'followup', 'people', 'documents'];

/** URL state of the contracts page: which view, which filter, which page. */
export interface ContractsSearch {
  view?: 'followups' | 'receivables';
  q?: string;
  status?: ServiceContractStatus;
  client?: string;
  sort?: string;
  page?: number;
}

export function parseContractsSearch(raw: Record<string, unknown>): ContractsSearch {
  const status = str(raw.status);
  const view = str(raw.view);
  return {
    view: view && VIEWS.includes(view) && view !== 'contracts' ? (view as ContractsSearch['view']) : undefined,
    q: str(raw.q),
    status: status && STATUSES.includes(status) ? (status as ServiceContractStatus) : undefined,
    client: str(raw.client),
    sort: str(raw.sort),
    page: pageOf(raw.page),
  };
}

/** URL state of one contract: the open tab (and, on the bill of quantities, the group filter). */
export interface ContractSearch {
  tab?: string;
  group?: string;
}

export function parseContractSearch(raw: Record<string, unknown>): ContractSearch {
  const tab = str(raw.tab);
  return { tab: tab && TABS.includes(tab) ? tab : undefined, group: str(raw.group) };
}
